module.exports = __webpack_public_path__ + "static/img/img08.5daa0c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img08.png
// module id = CXKB
// module chunks = 1